import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useAppDispatch, useAppSelector } from "src/hooks/redux";
import { getTrandingClonesAsync } from "src/redux/clones/actions";
import { selectorTrandingClones } from "src/redux/clones/selector";
import { TopPopularCloneCard } from "src/components/CloneCard/TopPopularCloneCard";
import { PopularCloneCard } from "src/components/CloneCard/PopularCloneCard";
import { Loader } from "src/components/Loader";
import { Sizes } from "src/@types/sizes";
import { trandingClonesTrns } from "../trns";

export const TrandingClones = () => {
  const { t } = useTranslation();

  const dispatch = useAppDispatch();

  const trandingClonesData = useAppSelector(selectorTrandingClones);

  const { isLoading, data } = trandingClonesData || {};

  useEffect(() => {
    if (!data) {
      dispatch(getTrandingClonesAsync());
    }
  }, [dispatch, data]);

  const trandingCloneResults = data?.results || [];

  return (
    <section className="container">
      <h2 className="text-center text-20 sm:text-40">
        {t(trandingClonesTrns.title)}
      </h2>

      {isLoading ? (
        <div className="flex justify-center items-center h-231.5 lg:h-310">
          <Loader size={Sizes.L} />
        </div>
      ) : (
        <div className="mt-3 gl:mt-10">
          <TopPopularCloneCard clone={trandingCloneResults[0]} />

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-5 mt-5">
            {Boolean(trandingCloneResults.length) &&
              trandingCloneResults.map((clone) => (
                <PopularCloneCard key={clone.id} clone={clone} />
              ))}
          </div>
        </div>
      )}
    </section>
  );
};
